<template>
  <v-card v-bind="$attrs">
    <v-toolbar flat v-bind="$attrs">
      <v-toolbar-title class="headline primary--text font-weight-medium">
        <v-icon class="primary--text" left>
          {{ groupIcon }}
        </v-icon>
        {{ groupTitle }}
      </v-toolbar-title>
    </v-toolbar>

    <v-row class="pa-4" dense>
      <v-col
        v-for="tank in tanks"
        :key="tank.id"
        cols="12"
        xl="3"
        lg="4"
        md="6"
      >
        <TankStatusCard
          class="mx-auto mb-8"
          :max-width="$vuetify.breakpoint.mobile ? '' : '350px'"
          max-height="500px"
          :tank="tank"
          :onUpdateTankStatusClicked="onUpdateTankStatusClicked"
          :disableCardActions="disableCardActions"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import TankStatusCard from './TankStatusCard.vue';

export default {
  name: 'TankStatusGroupCard',
  inheritAttrs: false,
  props: {
    groupTitle: String,
    groupIcon: String,
    tanks: Array,
    onUpdateTankStatusClicked: Function,
    disableCardActions: Boolean,
  },
  components: { TankStatusCard },
};
</script>
